import moment from 'moment'
import ClockSync from 'clocksync'
import config from 'lib/config'

export function createServerClock() {
  const clock = ClockSync({
    sendRequest: async (sync_id, cb) => {
      const res = await fetch(`${config.GRAPHQL_URL}/status`)
      const serverTime = new Date(res.headers.get('date'))
      cb(null, serverTime)
    }
  })
  clock.start()
  return clock
}

/*
 * Returns the same as Date.now(), however the date is checked against a server
 * so will be fairly accurate regardless of the time on the client.
 */
let clockInstance
export function now() {
  if (!clockInstance) {
    clockInstance = createServerClock()
  }
  return clockInstance.now()
}

export function toISODate(date) {
  return moment(date).format('YYYY-MM-DD')
}
